import { isNil } from "ramda";
import { isObject, isUndefined } from "ramda-adjunct";
import { compact } from "./compact";

export const get = <T>(object: T, path?: string | null, defaultValue?: unknown): any => {
  if (!path || !isObject(object)) {
    return defaultValue;
  }

  const result = compact(path.split(/[,[\].]+?/)).reduce((resultPath, key) => {
    if (isNil(resultPath)) {
      return resultPath;
    }

    // Check if resultPath is an object or array that can be indexed
    if (resultPath && typeof resultPath === "object") {
      return (resultPath as Record<string, any>)[key];
    }
    return undefined;
  }, object);

  return isUndefined(result) || result === object
    ? isUndefined(object[path as keyof T])
      ? defaultValue
      : object[path as keyof T]
    : result;
};
